import { useCallback } from "react";
import { useScenarioToast } from "domains/notification/hooks/useScenarioToast";
import Icon from "domains/ui/components/Icon";

import { Flex, HStack, Text, Tooltip } from "@chakra-ui/react";

type PanelInfoGridItemProps = {
  label: string;
  value: any;
  copyable?: boolean;
};

function PanelInfoGridItem({
  label,
  value,
  copyable: isCopyable,
}: PanelInfoGridItemProps) {
  const { infoToast } = useScenarioToast();

  const handleClick = useCallback(async () => {
    if (!(typeof value === "string" || typeof value === "number")) return;
    await navigator.clipboard.writeText(String(value));
    infoToast({
      title: "Copied to clipboard",
    });
  }, [infoToast, value]);

  return (
    <Tooltip
      isDisabled={!isCopyable}
      label="Copy to clipboard"
      openDelay={500}
      placement="left-start"
    >
      <Flex
        {...(isCopyable
          ? {
              borderRadius: "md",
              _hover: {
                bg: "whiteAlpha.100",
              },
              cursor: "pointer",
              onClick: handleClick,
            }
          : {})}
        w="100%"
        data-group
      >
        <HStack w="50%">
          {typeof label === "function" ? (
            label
          ) : (
            <Text color="textSecondary" size="body.md">
              {label}
            </Text>
          )}
          {isCopyable && (
            <Icon
              id="Ui/Copy"
              height="12px"
              visibility="hidden"
              _groupHover={{ visibility: "visible" }}
            />
          )}
        </HStack>
        <HStack w="50%">
          {typeof value === "function" ? (
            value
          ) : (
            <Text
              overflow="hidden"
              color="white.500"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              size="body.md"
            >
              {value}
            </Text>
          )}
        </HStack>
      </Flex>
    </Tooltip>
  );
}

export default PanelInfoGridItem;
